module.exports = __webpack_public_path__ + "img/folderFull.3bb95b17.svg";